import '../css/ProfilePage.css';
import React from 'react';
import {
  ProSidebar,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
  Menu,
  MenuItem,
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import {FaEdit, FaPlus, FaFile} from 'react-icons/fa';
import profImg from '../images/profImg.png';

// previously removed semantic-ui due package update error
// import 'semantic-ui-css/semantic.min.css';
import {Link} from 'react-router-dom';

const ProfilePage = () => {
  return (
    <div className="prof-body">
      <div className="prof-container">
        <div className="sidebar">
          <ProSidebar>
            <SidebarHeader>
              <div className="prof-img">
                <img src={profImg}></img>
              </div>
            </SidebarHeader>
            <SidebarContent>
              <div className="emp-content"> Employee Name </div>
              <Menu className="prof-menu" iconShape="square">
                <MenuItem icon={<FaFile />}>All Documents</MenuItem>
                <Link to="/create-doc">
                  <MenuItem icon={<FaPlus />}>Create Document</MenuItem>{' '}
                </Link>
                <MenuItem icon={<FaEdit />}>Saved Document</MenuItem>
              </Menu>
            </SidebarContent>
            <SidebarFooter>
              <button className="prof-button">Logout</button>
            </SidebarFooter>
          </ProSidebar>
          ;
        </div>
        <div className="prof-table">
          <table className="ui celled fixed single line table">
            <thead className="">
              <tr className="">
                <th className="id">ID</th>
                <th className="">Author</th>
                <th className="">Title</th>
                <th className="">Status</th>
              </tr>
            </thead>
            <tbody className="">
              <tr className="">
                <td className="">1</td>
                <td className="">Jane</td>
                <td className="">Research On Panda</td>
                <td>Approved</td>
              </tr>
              <tr className="">
                <td className="">2</td>
                <td className="">Ben</td>
                <td className="">Research On Panda</td>
                <td>Submitted</td>
              </tr>
              <tr className="">
                <td className="">3</td>
                <td className="">Danial</td>
                <td className="">Research On Panda</td>
                <td>Created</td>
              </tr>
              <tr className="">
                <td className="">4</td>
                <td className="">Henna</td>
                <td className="">Research On Panda</td>
                <td>In Progress</td>
              </tr>
              <tr className="">
                <td className="">5</td>
                <td className="">Henna</td>
                <td className="">Research On Panda</td>
                <td>In Progress</td>
              </tr>
              <tr className="">
                <td className="">6</td>
                <td className="">Henna</td>
                <td className="">Research On Panda</td>
                <td>In Progress</td>
              </tr>
              <tr className="">
                <td className="">7</td>
                <td className="">Henna</td>
                <td className="">Research On Panda</td>
                <td>In Progress</td>
              </tr>
              <tr className="">
                <td className="">8</td>
                <td className="">Henna</td>
                <td className="">Research On Panda</td>
                <td>In Progress</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
